import React from 'react';
import {
  RoiFormatter,
  DotDigitFormatter,
  JustValueFormatter,
  RoasFormatter,
} from 'components/tables/NinjaTable/formatters';
import { RoiDefinition, RoasDefinition, NameDefinition } from 'components/NameDefinition';

const WidgetsCommonColumns = () => [
  {
    name: 'Ad Spent',
    definition: <NameDefinition name='Ad Spent' definiton='All Ads Spent with Postbacks' />,
    key: 'ad_spent',
    type: 'spent',
    renderCell: JustValueFormatter,
    renderSummaryCell: JustValueFormatter,
    sortable: true,
    resizable: true,
  },
  {
    name: 'Gross Income',
    definition: <NameDefinition name='Gross Income' definiton='Gross Revenue from the sales' />,
    key: 'gross_income',
    type: 'income',
    renderCell: JustValueFormatter,
    renderSummaryCell: JustValueFormatter,
    sortable: true,
    resizable: true,
  },
  {
    name: 'Gross Profit',
    definition: <NameDefinition name='Gross Profit' definiton='Gross Income - COGS' />,
    key: 'gross_profit',
    type: 'profit',
    renderCell: JustValueFormatter,
    renderSummaryCell: JustValueFormatter,
    sortable: true,
    resizable: true,
  },
  {
    name: 'Net Profit',
    definition: <NameDefinition name='Net Profit' definiton='Gross Profit - Ad Spent' />,
    key: 'net_profit',
    type: 'profit',
    renderCell: DotDigitFormatter,
    renderSummaryCell: DotDigitFormatter,
    currency: true,
    sortable: true,
    resizable: true,
  },
  {
    name: <RoasDefinition />,
    key: 'roas',
    sortable: true,
    renderCell: RoasFormatter,
    renderSummaryCell: ({ row }) => {
      return row.roas && <RoasFormatter row={row} />;
    },
    resizable: true,
  },
  {
    name: <RoiDefinition />,
    key: 'roi',
    sortable: true,
    renderCell: RoiFormatter,
    renderSummaryCell: ({ row }) => {
      return row.roi && <RoiFormatter row={row} />;
    },
    resizable: true,
  },
];

export default WidgetsCommonColumns;
